// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"8aa88da7","222":"043d2b2e"}[chunkId] + ".chunk.css";
};